module.exports = __webpack_public_path__ + "static/media/order.b6e35be7.svg";